export default {"src":"/_next/static/media/payment-ideal.6857b018.svg","height":30,"width":45,"blurWidth":0,"blurHeight":0};